import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const ChevronDownIcon = ({ color, ...rest }: { color?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...rest}>
      <path
        fill={color ?? token.colorBorder}
        fillRule="evenodd"
        d="M5.172 5.586l2.827 2.828 2.83-2.828L12.242 7l-2.83 2.828h.001L8 11.243 3.757 7l1.415-1.414z"
      />
    </svg>
  );
};

export default ChevronDownIcon;
